import React from 'react';
import { styled, ThemeProvider } from '@mui/system';
import { ChromePicker, BlockPicker, CirclePicker, CompactPicker } from 'react-color';
import theme from '../Styles/MuiTheme';
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import PickerColor from './PickerColor';

const ColorBox = styled('div')({
    backgroundColor: (props) => props.backgroundColor,
    width: '36px',
    height: '14px',
    borderRadius: '2px',
    display: 'inline-block',
    cursor: 'pointer',
    border: (props) => props.selected ? '2px solid red' : 'none',
});

const colors = {
    "Black": "rgb(0, 0, 0)",
    "Dark Gray": "rgb(51, 51, 51)",
    "Gray": "rgb(77, 77, 77)",
    "Light Gray": "rgb(102, 102, 102)",
    "Medium Gray": "rgb(128, 128, 128)",
    "Slate Gray": "rgb(153, 153, 153)",
    "Light Slate Gray": "rgb(179, 179, 179)",
    "White": "rgb(255, 255, 255)",
    "Brown": "rgb(121, 85, 72)"
};

// const ColorPicker = styled('div')({
//     // position: 'absolute',
//     zIndex: '2',
//     border: (props) => props.selected ? '2px solid red' : 'none',
// });

function FeedbackColorPicker(props) {
    const { value, setValue, defVal, label } = props;
    // console.log("value: ", value)
    // console.log("setValue: ", setValue)
    // console.log("defVal: ", defVal)
    // console.log("label: ", label)

    const [backgroundColor, setBackgroundColor] = React.useState(value || defVal);

    const handleColorChange = (color) => {
        console.log("color: ", color)
        // const newColor = `rgb(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b})`;
        const newColor = `${color}`;
        console.log("newColor: ", newColor, color.hex)
        setBackgroundColor(color.hex);
        setValue(newColor, props.pId, 'color');
    };


    return (
        <ThemeProvider theme={theme}>
            <Typography id="input-slider" gutterBottom align="left" variant="caption">
            {label}
            </Typography>
            <Grid>
                <Grid item justifyContent="center" alignItems="center" style={{marginLeft: '10px'}}>
                    <PickerColor colors={colors} handleColorChange={handleColorChange} />
                </Grid>
            </Grid>
        </ThemeProvider>
    );
}

export default FeedbackColorPicker;
